import axios from "./backendAxios";
import errors from "../errors";

const noop = () => {};

const axiosRoutes = {
  orderRoute: async (routeId, order) => {
    return axios.put(`route/${routeId}/order`, { order });
  },
  createNewRoute: async (data, onSuccess = noop, onFail = noop) => {
    try {
      const res = await axios.post("route/add", data);

      onSuccess(res.data);
    } catch (error) {
      errors.report(error);
      onFail(error);
    }
  },
  deleteRoute: async (data, onSuccess = noop, onFail = noop) => {
    try {
      const res = await axios.delete("route/" + data.routeId + "/delete", data);

      onSuccess(res.data);
    } catch (error) {
      errors.report(error);
      onFail(error);
    }
  },
  getAllRoutes: async (data, onSuccess = noop, onFail = noop) => {
    try {
      const params = new URLSearchParams({ take: 10000 });
      if (data.searchPhrase) params.set("searchPhrase", data.searchPhrase);
      const res = await axios.get(
        "route/company/" + data.companyId + "?" + params.toString(),
      );

      onSuccess(res.data);
    } catch (error) {
      errors.report(error);
      onFail(error);
    }
  },
  getAllRoutesAsync: async (companyId, abortSignal, searchPhrase) => {
    try {
      const params = new URLSearchParams({ take: 10000 });
      if (searchPhrase) params.set("searchPhrase", searchPhrase);
      const res = await axios.get(
        "route/company/" + companyId + "?" + params.toString(),
        {
          signal: abortSignal,
        },
      );
      return res.data;
    } catch (error) {
      errors.report(error);
      throw error;
    }
  },
  // Get jobs list (include duplicate) for single route by routeId
  getJobListByRouteId: async (data, onSuccess = noop, onFail = noop) => {
    try {
      const res = await axios.get("route/" + data.routeId + "/jobs/all");
      onSuccess(res.data);
    } catch (error) {
      errors.report(error);
      onFail(error);
    }
  },
  getRouteById: async (data, onSuccess = noop, onFail = noop) => {
    try {
      const res = await axios.get("route/" + data.routeId);
      onSuccess(res.data);
    } catch (error) {
      errors.report(error);
      onFail(error);
    }
  },
  getRouteWithJobs: async (routeId, abortSignal) => {
    try {
      const res = await axios.get(`route/${routeId}?include=jobs`, {
        signal: abortSignal,
      });
      return res.data;
    } catch (error) {
      errors.report(error);
      throw error;
    }
  },
  updateRouteTags: async (routeId, tags) => {
    try {
      const res = await axios.post("route/update", { _id: routeId, tags });
      return res.data;
    } catch (error) {
      errors.report(error);
      throw error;
    }
  },
  updateRoute: async (data, onSuccess = noop, onFail = noop) => {
    try {
      const res = await axios.post("route/update", data);

      onSuccess(res.data);
    } catch (error) {
      errors.report(error);
      onFail(error);
    }
  },
};

export default axiosRoutes;
